export default {
    _sections: null,
    _activeClass:'tellus-products__row--active', 
    init() {
        this._sections = document.querySelectorAll('[data-tellus-products]');
        if (!this._sections) {
            return;
        }

        Array.prototype.forEach.call(this._sections, section => {
            const rows   = section.querySelectorAll('[data-tellus-products-row]');
            const button = section.querySelector('[data-tellus-show-more]');
            const heartButtons = section.querySelectorAll('button.heart');
            
            if (!rows || !button) {
                return;
            }

            button.addEventListener('click', () => {
                for (const [index, row] of rows.entries()) {
                    if (!row.classList.contains(this._activeClass)) {
                        row.classList.add(this._activeClass);

                        if (index === rows.length - 1) {
                            button.classList.remove('tellus-products__see-more--active')
                        }

                        break;
                    }
                }
            });

            for (const heartButton of heartButtons ) {
                heartButton.addEventListener('click', () => {
                    this.toggleFavorites(event);
                    event.preventDefault();
                });
            }

        });

        this.setFavoritesOnload();
        

    },
	reload() {
		this.init();
    },
    toggleFavorites: function (event) {
        if (event.target.className == "heart heart--active") event.target.className = "heart";
        else event.target.className = "heart heart--active";

        var currentID = parseInt(event.target.id);
        var favoritesLocalStorageObject = JSON.parse(localStorage.getItem('favorites'));

        var header_favorites_icon = document.getElementById("header__favorites--icon");
        if ( favoritesLocalStorageObject && favoritesLocalStorageObject.includes(currentID) ) {
            for (var i = 0; i < favoritesLocalStorageObject.length; i++) {
                if (favoritesLocalStorageObject[i]==currentID) favoritesLocalStorageObject.splice(i, 1);
            }
            if ( favoritesLocalStorageObject.length == 0 && header_favorites_icon.classList.contains("header__favorites--icon-active") ) {
                header_favorites_icon.classList.remove("header__favorites--icon-active");
            }
        }
        else if (favoritesLocalStorageObject) {
            favoritesLocalStorageObject.push(currentID);
            if ( favoritesLocalStorageObject.length > 0 && !header_favorites_icon.classList.contains("header__favorites--icon-active") ) {
                header_favorites_icon.classList.add("header__favorites--icon-active");
            }
        }
        else {
            favoritesLocalStorageObject = [ currentID ];
            if ( favoritesLocalStorageObject.length > 0 && !header_favorites_icon.classList.contains("header__favorites--icon-active") ) {
                header_favorites_icon.classList.add("header__favorites--icon-active");
            }
        }

        localStorage.setItem('favorites', JSON.stringify(favoritesLocalStorageObject) );
    },
    setFavoritesOnload: function (event) {
        var currentID;
        var favoritesObject = JSON.parse(localStorage.getItem('favorites'));
        setTimeout(() => {
            //var allHeartElements = this.$el.getElementsByClassName('heart');
            var allHeartElements = document.querySelectorAll('button.heart');
            for (var heartsIndex = 0; heartsIndex < allHeartElements.length; heartsIndex++) {
                allHeartElements[heartsIndex].classList.remove("heart--active");
            }
            if ( favoritesObject ) {
                for (var lsIndex = 0; lsIndex < favoritesObject.length; lsIndex++) {
                    for (var heartsIndex = 0; heartsIndex < allHeartElements.length; heartsIndex++) {
                        if (allHeartElements[heartsIndex] && allHeartElements[heartsIndex].id) {
                            if ( favoritesObject[lsIndex] == allHeartElements[heartsIndex].id ) {
                                allHeartElements[heartsIndex].classList.add("heart--active");
                            }
                        }
                    }
                }
            }
        }, 2000);
    },
}